import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { getModule} from 'vuex-module-decorators';
import axios, {AxiosPromise}  from 'axios';

import User from "@/module/store/user";
import {CONFIG_ENV} from '@/config';
import {LocalStorage} from "quasar";
import  {getProfileImgAsString}  from '@/module/utils';

interface I_AuthenticateUsingEmail{
    email:string,
    password:string,
}


interface I_AjaxResponse_RegisterUsingEmail{
    status:number,
    statusText:string,
    data: {
        status: string,email_is_checked:string, message: string,userid:string,user_email:string,lastName:string,firstName:string,token_for_permanent_session:string,track_date_last_need_to_check_email:string
    }
}

interface I_AjaxResponse_ResendForValidateEmail{
    status:number,
    statusText:string,
    data: {
        status: string,status_email_for_validate_mail_adress:string, message: string
    }
}

@Component({components:{}})
export default class Autentificare extends Vue {
    @Prop() prop_after_validare_email!: string;
    loading:boolean=false;
    isPwdHidden:boolean=true;
    isRetypedPwdHidden:boolean=true;
    IsTermsAndConditions_Accepted:boolean=false;
    after_validare_email:boolean=false;
    showAlertForNeedToReCheckEmail:boolean=false;
    track_date_last_need_to_check_email:string='';
    register_option='using_mail';
    athenticateUsingEmail:I_AuthenticateUsingEmail={
        email:'',
        password:'',
    }

    $refs:any;
    private userStore=getModule(User);


    async authenticateWithEmailAndPassword(){
        const vueInst=this;
        let res = await <Promise<I_AjaxResponse_RegisterUsingEmail>> axios.post(`${CONFIG_ENV.URL_USER.authenticateWithEmailAndPassword}`,vueInst.athenticateUsingEmail);
        return res;
    }

    async resendValidationMail(){
        const vueInst=this;
        let res = await <Promise<I_AjaxResponse_ResendForValidateEmail>> axios.post(`${CONFIG_ENV.URL_USER.resendForValidateEmail}`,vueInst.athenticateUsingEmail);
        return res;
    }

    async resetPasswordForMail(pemail:string){
        const vueInst=this;
        var params = new URLSearchParams();
        params.append('email', pemail);
        let res = await <Promise<I_AjaxResponse_ResendForValidateEmail>> axios.post(`${CONFIG_ENV.URL_USER.resetPasswordForEmail}`,params);
        return res;
    }


    tryToResendValidationMail(){
        const vueInst=this;
        vueInst.resendValidationMail().then((response:I_AjaxResponse_ResendForValidateEmail)=>{
            if(response.data.status_email_for_validate_mail_adress=="success"){
                vueInst.showAlertForNeedToReCheckEmail=false;
                vueInst.$q.notify({
                    color: 'teal',
                    textColor: 'white',
                    position:'bottom-right',
                    timeout: 3000,
                    icon: 'fas fa-exclamation-triangle',
                    message: 'Un nou mail cu instructiuni de validare a contului a fost trimis catre dvs. Verificati contul de mail!'
                });
                vueInst.$router.push({name: 'bine_ai_venit'});
            }
        });
    }

    resetPasswordForMailAndSendIt(){
        const vueInst=this;
        if(vueInst.athenticateUsingEmail.email.length>3){
            vueInst.resetPasswordForMail(vueInst.athenticateUsingEmail.email).then((response:I_AjaxResponse_ResendForValidateEmail)=>{
                if(response.data.status=="success"){
                    vueInst.showAlertForNeedToReCheckEmail=false;
                    vueInst.$q.notify({
                        color: 'teal',
                        textColor: 'white',
                        position:'bottom-right',
                        timeout: 3000,
                        icon: 'fas fa-exclamation-triangle',
                        message: 'Parola a fost resetata si trimisa pe mail la adresa indicata de dvs. Verificati contul de mail!'
                    });
                }
            });
        }else{
            vueInst.$q.notify({
                color: 'red',
                textColor: 'white',
                position:'top-right',
                timeout: 3000,
                icon: 'fas fa-exclamation-triangle',
                message: 'Pentru resetare, completati adresa de mail!'
            });
        }
    }

    onResetFormAuthenticateUsingEmail(){
        this.athenticateUsingEmail.email='';
        this.athenticateUsingEmail.password='';
    }

    onSubmitForAuthenticateUsingEmail(){
        const vueInst=this;
        vueInst.authenticateWithEmailAndPassword().then(function(presponse:I_AjaxResponse_RegisterUsingEmail){
            if(presponse.data.status=='success'){
                LocalStorage.set('isAuthenticated', 'yes');
                if(presponse.data.email_is_checked=='y'){
                    LocalStorage.set('emailIsChecked', 'yes');
                }
                LocalStorage.set('userEmail', presponse.data.user_email);
                LocalStorage.set('token_for_permanent_session', presponse.data.token_for_permanent_session);
                LocalStorage.set('userid', presponse.data.userid);
                vueInst.userStore.set_user({
                    userid:presponse.data.userid,
                    email:presponse.data.user_email,
                    lastName:presponse.data.lastName,
                    firstName:presponse.data.firstName,
                    isEmailChecked:true,
                    isAuthenticated:true,
                    csrf_token:''
                });
                //vueInst.$eventHub.$emit('infofromchildCommand','GIFT_SAVED');
                vueInst.$root.$emit('eventFromAutentificare', 'isAuthenticated')
                getProfileImgAsString(presponse.data.userid).then((response:any)=>{
                    LocalStorage.set('MyImgProfileString64', response.data);
                    vueInst.userStore.set_myimgprofilestring64r(response.data);
                });
                vueInst.$router.push({ name: 'my_home_page' });
            }
            else{
                vueInst.$q.notify({
                    color: 'red-5',
                    textColor: 'white',
                    position:'top-right',
                    icon: 'fas fa-exclamation-triangle',
                    message: presponse.data.message
                });
                if(presponse.data.email_is_checked=='no') {
                    vueInst.showAlertForNeedToReCheckEmail=true;
                    vueInst.track_date_last_need_to_check_email= presponse.data.track_date_last_need_to_check_email;
                }

            }
        });
    }

    constructor(){
        super();
    }

    get titleRegisterType():string{
        let v_return:string='';
        if(this.register_option=='using_mail'){
            v_return=' Cu Adresa de Mail';
        }
        if(this.register_option=='using_facebook'){
            v_return=' Cu Contul de Facebook';
        }
        if(this.register_option=='using_gmail'){
            v_return=' Cu Contul de Gmail';
        }
        return v_return;

    }

    onMetodaInregistrareClick(p_mod_inregistrare:string){
        const vueInst=this;
        vueInst.register_option=p_mod_inregistrare;
    }

    activated(){
        const vueInst=this;
        let userEmailInLocalStorage=LocalStorage.getItem('userEmail');
        if(userEmailInLocalStorage && userEmailInLocalStorage.length>3){
            vueInst.athenticateUsingEmail.email=userEmailInLocalStorage;
        }
        if(this.prop_after_validare_email && this.prop_after_validare_email=='yes'){
                this.after_validare_email=true;
        }
    }

}
